import React from 'react'
import Popup from '../../../../../components/popup/Popup'
import Button from '../../../../../components/button/Button'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import styles from "../ManageFederalForms.styles"
import commonStyles from "../../ManageForms.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import MultiSelectDropdownWButton from '../../../../../components/multiselect/multiselectdropdownwbuttons/MultiSelectDropdownWButtons'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'

const ExportToExcel = ({ title, isPopupOpen, onCloseCb, exportToExcelBySelectedPayers = false, exportToExcelAllPayers = false, federalForms = [], onSelectFormCb = () => { }, onSubmitCb = () => { }, exportToExcelStates = {}, federalPayers = [], federalTaxYear = [], onSelectOptionsCb = () => { } }) => {
    return (
        <>
            <Popup
                title={title}
                isPopupOpen={isPopupOpen}
                onCloseCb={onCloseCb}
                childrenStyles={styles.childrenStyles}
                customPopupSyles={styles.customPopupSyles}
            >
                <div style={styles.dropdownContainer}>
                    {exportToExcelBySelectedPayers &&
                        <MultiSelectDropdownWButton
                            label='Select Payer'
                            options={federalPayers}
                            searchFieldPlaceholder="Search by payer"
                            suffixProps={{ icon: VEC_ICON_NAME.CARET_DOWN }}
                            onSelectOptionsCb={onSelectOptionsCb}
                        />
                    }

                    {exportToExcelAllPayers &&
                        <SelectDropdown
                            label='Select Tax Year'
                            name="TaxYear"
                            options={federalTaxYear}
                            dropdownMenuStyle={styles.dropdownMenu}
                            onSelectCb={onSelectFormCb}
                            value={exportToExcelStates.TaxYear}
                        />
                    }

                    <SelectDropdown
                        label='Select Form'
                        name="Form"
                        value={exportToExcelStates.Form}
                        options={federalForms}
                        dropdownMenuStyle={styles.dropdownMenu}
                        onSelectCb={onSelectFormCb}
                    />
                </div>

                <div style={styles.buttonsContainer}>
                    <Button style={commonStyles.button} onClickCb={onSubmitCb}>Submit</Button>
                    <Button style={commonStyles.button} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={onCloseCb}>Cancel</Button>
                </div>
            </Popup>
        </>
    )
}

export default ExportToExcel
